import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
const BooksPage = () => {
  return <div className="min-h-screen bg-white text-[#333333] font-serif" data-id="element-92">
      <Header data-id="element-93" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-94">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-95">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-96">
            <Navigation data-id="element-97" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-98">
            <div className="max-w-2xl" data-id="element-99">
              <div className="mb-8" data-id="element-100">
                <div className="text-base mb-4" data-id="element-101">Author</div>
                <ul className="list-none space-y-2" data-id="element-102">
                  <li data-id="element-103">
                    <Link to="/body-not-thing" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-104">
                      The Body Is Not A Thing (Coming soon...)
                    </Link>
                  </li>
                  <li data-id="element-105">
                    <Link to="/quarry" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-106">
                      The Quarry (Self-published, 2022)
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mb-8" data-id="element-107">
                <div className="text-base mb-4" data-id="element-108">Editor</div>
                <ul className="list-none space-y-2" data-id="element-109">
                  <li data-id="element-110">
                    <a href="https://www.phaidon.com/monacelli/art-and-photography/emerald-drifters-9781580936873/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-111">
                      Emerald Drifters, Cig Harvey (Monacelli)
                    </a>
                  </li>
                  <li data-id="element-112">
                    <a href="https://www.libraryman.se/odette-england-the-long-shadow/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-113">
                      The Long Shadow, Odette England (Libraryman)
                    </a>{' '}
                    <em data-id="element-114">*text edit only</em>
                  </li>
                  <li data-id="element-115">
                    <a href="https://www.youtube.com/watch?v=Jqhk4oU-suA" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-116">
                      Bluest Bruise, Joan Haseltine (For the Birds Trapped in
                      Airports)
                    </a>
                  </li>
                  <li data-id="element-117">
                    <a href="https://www.schiltpublishing.com/shop/books/new-releases/you-refuse-to-believe-that-you-ever-liked-pink/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-118">
                      You Refuse To Believe You Ever Liked Pink, Dena Eber
                      (Schildt Publishing)
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mb-8" data-id="element-119">
                <div className="text-base mb-4" data-id="element-120">What does an editor do?</div>
                <ul className="list-none space-y-2" data-id="element-121">
                  <li className="flex" data-id="element-122">
                    <span className="mr-2" data-id="element-123">•</span>
                    <div data-id="element-124">
                      Refines concept and narrative to support the book's core
                      themes and intent.
                    </div>
                  </li>
                  <li className="flex" data-id="element-125">
                    <span className="mr-2" data-id="element-126">•</span>
                    <div data-id="element-127">
                      Develops image sequence and selection to build visual and
                      emotional rhythm.
                    </div>
                  </li>
                  <li className="flex" data-id="element-128">
                    <span className="mr-2" data-id="element-129">•</span>
                    <div data-id="element-130">
                      Edits all written material — captions, statements, essays
                      — for clarity, tone, and alignment.
                    </div>
                  </li>
                  <li className="flex" data-id="element-131">
                    <span className="mr-2" data-id="element-132">•</span>
                    <div data-id="element-133">
                      Ensures consistency across text, design, and structure in
                      service of the story.
                    </div>
                  </li>
                  <li className="flex" data-id="element-134">
                    <span className="mr-2" data-id="element-135">•</span>
                    <div data-id="element-136">
                      Collaborates closely with photographer, designer, and
                      publisher to uphold the vision.
                    </div>
                  </li>
                </ul>
              </div>
              <div data-id="element-137">
                <p data-id="element-138">
                  If you are interested in working together on a photo book
                  please email me directly to enquire.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default BooksPage;